import React from "react";
import { Link } from "react-router-dom";

function HomeIcon({ className = "home-icon" }) {
  return (
    <Link
      to="/browse"
      className={className}
      aria-label="Zur Übersicht"
      title="Zur Übersicht"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        focusable="false"
      >
        <path
          d="M3 11L12 4L21 11"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 10V20H19V10"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
  );
}

export default HomeIcon;